import React, { useRef, useEffect } from 'react';

const MessageList = ({ messages, chatType }) => {
    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    if (messages.length === 0) {
        return (
            <div className="messages-area">
                <div style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: '2rem', position: 'relative', zIndex: 1 }}>
                    Нет сообщений. Напишите что-нибудь!
                </div>
            </div>
        );
    }

    return (
        <div className="messages-area">
            {messages.map(msg => (
                <div key={msg.id} className={`message ${msg.type}`}>
                    <div className="message-bubble">
                        {chatType === 'group' && msg.type === 'incoming' && (
                            <div className="message-sender">
                                <i className="fas fa-user"></i> {msg.sender}
                            </div>
                        )}
                        <div className="message-text">{msg.text}</div>
                        <div className="message-time">{msg.time}</div>
                    </div>
                </div>
            ))}
            <div ref={messagesEndRef} />
        </div>
    );
};

export default MessageList;
